import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangelogService } from 'src/app/services/gui/changelog/changelog.service';
import { StatusCodes, getReasonPhrase } from 'http-status-codes';
import { APIService } from '../../services/api/api.service';

@Component({
  selector: 'sb-page-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: false,
})
export class ErrorComponent implements OnInit {
  error: any;

  status: StatusCodes;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private changelogService: ChangelogService,
    private apiService: APIService
  ) {
    this.error = this.apiService.forbiddenError;
  }

  returnToRoot() {
    this.router.navigate(['/']).then();
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      let parsed: boolean = false;
      if (params.error) {
        try {
          this.status = +params.error;
        } catch (err) {}
        if (!isNaN(this.status)) {
          parsed = true;
        }
      }
      if (!parsed) {
        this.returnToRoot();
      }
    });
  }

  getReasonPhrase() {
    try {
      if (this.status) {
        return getReasonPhrase(this.status);
      }
      throw new Error('No Reason provided');
    } catch (err) {
      return err;
    }
  }

  getFrontendVersion(): string {
    return this.changelogService.getFrontendVersion();
  }

  getBackendVersion(): string {
    return this.changelogService.getBackendVersion();
  }

  getFrontendChangelog(): string[] {
    return this.changelogService.getFrontendChangelog();
  }

  getBackendChangelog(): string[] {
    return this.changelogService.getBackendChangelog();
  }

  getFrontendName() {
    return this.changelogService.getFrontendName();
  }

  getBackendName() {
    return this.changelogService.getBackendName();
  }
}
